import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { Router, withRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import initI18n from './services/i18n'
import { history } from './services/routing'
import { store } from './services/redux'

import './services/yup'

import { getBrandName } from './config'

const ConnectedApp = React.lazy(() => import('./App'))

const chooseVwBrand = (brand: string): string => {
  switch (brand) {
    case 'vwfs':
      return 'bluelabel'
    case 'vw6':
      return 'vw6'
    case 'vwcv':
      return 'vw6'
    case 'vwn':
      return 'vw6'
    default:
      return brand
  }
}

const getStyles = (brand: string): Promise<unknown> =>
  import(
    `@vwfs-bronson/bronson-${
      brand.includes('vw') ? chooseVwBrand(brand) : brand
    }/dist/css/style.min.css`
  ).then(() => import('./styles.scss'))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const PositionRestore = withRouter(
  (props: { location: { pathname: string; state?: unknown } }) => {
    const [location, setLocation] = React.useState(props.location.pathname)
    if (location !== props.location.pathname) {
      setLocation(props.location.pathname)
      const locationState = props.location.state as
        | { sectionId?: string }
        | undefined
      if (
        (locationState && locationState.sectionId === undefined) ||
        (locationState && locationState.sectionId === '')
      ) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }
    }

    return null
  }
)

function Init(): React.ReactElement | null {
  const [loaded, setLoaded] = React.useState(false)
  React.useEffect(() => {
    Promise.all([getStyles(getBrandName()), initI18n(getBrandName())]).then(
      () => {
        setLoaded(true)
      }
    )
  }, [])
  return loaded ? (
    <React.Suspense fallback={null}>
      <Provider store={store}>
        <Router history={history}>
          <PositionRestore />
          <ConnectedApp />
        </Router>
      </Provider>
    </React.Suspense>
  ) : null
}

function render(): void {
  const rootElement = document.getElementById('root')
  if (!rootElement) {
    throw new Error('Root element not found')
  }
  const root = ReactDOM.createRoot(rootElement)
  root.render(<Init />)
}

render()
